import { ISingleEpletMmRisk } from "./single-eplet-mm-risk";

export interface IDonorDeclines {
    centerAlias: string,
    donorAlias: string,
    abo: string,
    age: number,
    weight: number,
    laterality: string,
    creatinineClearance: number,
    ebv: string,
    cmv: string,
    singleEpletMmRisk: ISingleEpletMmRisk,
    totalHlaPoints: number,
    bmtMm: number,
    isAccepted: boolean,
    decisionDateTime: string,
    isPotentialDonor: boolean,
    isHistoric: boolean,
    isBadAgeMatch: boolean,
    isPairedDonor: boolean
    isPotentialHistoricDonor: boolean,
    isPotentialAllTimeDonor: boolean,
    hardBlockReason: string
}